import ZoButton from '@zonofi/zo-components/input/zo-button/zo-button';
import React from 'react';
import './retrain-agent-screen.scss';
import { FileCard, GIFS, SVGS } from '@zonofi/gandalf-components';
import { useRetrainAgentScreen } from '@zonofi/gandalf-utilities';
import { isEmpty } from 'lodash';

export const RetrainAgentScreen: React.FC = () => {
  const {
    areFilesBeingFetched,
    deleteKnowledgeFile,
    downloadKnowledgeFile,
    handleFileChange,
    handleSelect,
    inputRef,
    isTraining,
    knowledgeFiles,
    navigateBackToAgentScreen,
    startAgentTraining,
    trainingCompleted,
    uploadingSampleFile,
    uploadSampleFile,
    viewKnowledgeFile,
    viewSampleFile,
  } = useRetrainAgentScreen();
  return (
    <div className="retrain-agent-screen">
      <div className="retrain-agent-screen-header">
        <img
          src={SVGS.BackIcon}
          alt=""
          className="retrain-agent-screen-header-icon"
          onClick={navigateBackToAgentScreen}
        />
        <span className="retrain-agent-screen-header-text primary-font-semibold">
          Retrain ZöAI Agent
        </span>
      </div>
      <div className="retrain-agent-screen-body">
        <span className="retrain-agent-screen-body-text primary-font-semibold">
          Uploaded files
        </span>
        {areFilesBeingFetched ? (
          <div className="upload-knowledge-files-loading">
            <span className="upload-knowledge-files-loading-loader"></span>
          </div>
        ) : (
          knowledgeFiles?.map((file, index) => {
            const truncateFileName = (name: string, maxLength = 15): string => {
              const lastDotIndex = name.lastIndexOf('.');
              if (lastDotIndex === -1 || lastDotIndex === 0) return name;

              const base = name.slice(0, lastDotIndex);
              const ext = name.slice(lastDotIndex);

              if (base.length <= maxLength) return name;

              const start = base.slice(0, maxLength - 3);
              const end = base.slice(-2);
              return `${start}...${end}${ext}`;
            };
            return (
              <FileCard
                key={index}
                deleteFile={() => deleteKnowledgeFile(file?.id)}
                downloadFile={() => downloadKnowledgeFile(file?.id)}
                fileName={truncateFileName(file.name)}
                viewFile={() => viewKnowledgeFile(file?.id)}
              />
            );
          })
        )}
        {!areFilesBeingFetched && (
          <>
            <div
              className="retrain-agent-screen-body-upload-section"
              onClick={handleSelect}
            >
              <div className="retrain-agent-screen-body-upload-section-icon">
                <img src={SVGS.AddBlueIcon} alt="" />
              </div>
              <div className="retrain-agent-screen-body-upload-section-text">
                <span className="section-heading primary-font-semibold">
                  Upload Knowledge Files
                </span>
                <span className="section-description primary-font-regular">
                  File format are text .pdf and .docx up to 45 MB size.
                </span>
              </div>
            </div>
            <input
              type="file"
              ref={inputRef}
              onChange={handleFileChange}
              multiple
              accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.csv"
              style={{ display: 'none' }}
            />
          </>
        )}
      </div>
      {!isEmpty(knowledgeFiles) && (
        <div className="retrain-agent-screen-footer">
          <ZoButton
            label={'Upload & Train Agent'}
            onClick={startAgentTraining}
            className="retrain-agent-screen-footer-btn"
          />
        </div>
      )}
      {isEmpty(knowledgeFiles) && !areFilesBeingFetched && (
        <div className="retrain-agent-screen-dialog">
          <span className="retrain-agent-screen-dialog-text primary-font-semibold">
            No knowledge file? Upload this sample to train the agent.
          </span>
          <div className="retrain-agent-screen-dialog-content">
            <div className="dialog-file-card">
              <img
                src={SVGS.Document}
                alt=""
                className="dialog-file-card-icon"
                width={24}
                height={24}
              />
              <div className="dialog-file-card-details">
                <span className="dialog-file-card-details-heading primary-font-regular">
                  Sample document.txt
                </span>
              </div>
            </div>
            <div className="dialog-buttons">
              <ZoButton
                label={'View File'}
                onClick={viewSampleFile}
                className="dialog-btn view-btn"
              />
              <ZoButton
                label={'Upload This File'}
                onClick={uploadSampleFile}
                className="dialog-btn upload-btn"
                isLoading={uploadingSampleFile}
              />
            </div>
          </div>
        </div>
      )}
      {isTraining && (
        <div className="retrain-agent-screen-training-overlay">
          <div className="retrain-agent-screen-training-drawer">
            {!trainingCompleted ? (
              <div className="retrain-agent-screen-training-content">
                <img
                  src={GIFS.EducationalRobot}
                  alt=""
                  className="retrain-agent-screen-training-image"
                />
                <span className="retrain-agent-screen-training-heading primary-font-bold">
                  Agent is getting trained...
                </span>
              </div>
            ) : (
              <div className="retrain-agent-screen-training-content">
                <img
                  src={GIFS.ExcitedRobot}
                  alt=""
                  className="retrain-agent-screen-training-image"
                />
                <div className="retrain-agent-screen-training-text">
                  <span className="retrain-agent-screen-training-ready-heading primary-font-bold">
                    Agent is ready to test.
                  </span>
                </div>
                <ZoButton
                  onClick={navigateBackToAgentScreen}
                  label="Test Your Agent"
                  endIcon={<img src={SVGS.RightArrowIcon} alt="" />}
                  className="retrain-agent-screen-training-test-button"
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
